// Bounded line comparison: large replacements use a coarse diff instead of
// allocating an unbounded matrix. Equal prefixes and suffixes are retained.
export function lineDiff(before, after) {
    const lines = text => text.match(/[^\n]*\n|[^\n]+$/g) || []
    const a = lines(before), b = lines(after), prefix = [], suffix = []
    let start = 0, endA = a.length, endB = b.length
    while (start < endA && start < endB && a[start] === b[start]) {
        prefix.push({ kind: "equal", text: a[start++] })
    }
    while (endA > start && endB > start && a[endA - 1] === b[endB - 1]) {
        suffix.push({ kind: "equal", text: a[--endA] })
        endB--
    }
    const left = a.slice(start, endA), right = b.slice(start, endB)
    const middle = []
    if ((left.length + 1) * (right.length + 1) > 1_000_000) {
        left.forEach(text => middle.push({ kind: "removed", text }))
        right.forEach(text => middle.push({ kind: "added", text }))
    } else {
        const width = right.length + 1
        const table = new Uint32Array((left.length + 1) * width)
        for (let i = left.length - 1; i >= 0; i--) {
            for (let j = right.length - 1; j >= 0; j--) {
                table[i * width + j] = left[i] === right[j]
                    ? table[(i + 1) * width + j + 1] + 1
                    : Math.max(table[(i + 1) * width + j], table[i * width + j + 1])
            }
        }
        let i = 0, j = 0
        while (i < left.length || j < right.length) {
            if (i < left.length && j < right.length && left[i] === right[j]) {
                middle.push({ kind: "equal", text: left[i++] }); j++
            } else if (i < left.length && (j === right.length || table[(i + 1) * width + j] >= table[i * width + j + 1])) {
                middle.push({ kind: "removed", text: left[i++] })
            } else {
                middle.push({ kind: "added", text: right[j++] })
            }
        }
    }
    return [...prefix, ...middle, ...suffix.reverse()]
}
